import { useEffect, useRef, useState } from "react";
import Button from "@components/global/new/Button/Button";
import Field from "@components/global/new/Field/Field";
import Icon from "@components/global/new/Icon/Icon";
import SmallLink from "@components/global/new/SmallLink/SmallLink";
import Title from "@components/global/new/Title/Title";
import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import cn from "classnames";
import styles from "./TwoFaModal.module.scss";
import { useTwoFaModalControl } from "./useTwoFaModalControl";
import { REACT_RECAPTCH_KEY, IS_DEBUG } from "../../../../config";
import Error from "@components/global/new/Error/Error";
import ReCAPTCHA from "react-google-recaptcha";

import close from "@assets/icons/close.svg";

export interface ITwoFaModalProps extends CommonModalPropsI {
  readonly email: string;
  readonly password: string;
}

function TwoFaModal({ ...props }: ITwoFaModalProps) {
  // если поменялся стэйт - ресетим значения филдов
  const [reset, setReset] = useState<number>(0);
  const control = useTwoFaModalControl(props);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (ref.current && ref.current.parentElement) {
      ref.current.parentElement.style.width = "350px";
    }
  }, [ref]);

  const compireOnClick = () => {
    control.onChangeWindow();
    setReset((prev) => prev + 1);
  };

  return (
    <div className={styles.wrapper} ref={ref}>
      <Icon
        src={close}
        className={styles.close}
        onClick={control.onCloseHandler}
        noHover
      />
      <form className={styles.form} onSubmit={control.formControl}>
        <Title className={styles.title}>
          {control.resetFa
            ? props.formatMessage({ id: "modal.2fa.title_reset" })
            : props.formatMessage({ id: "modal.2fa.title" })}
        </Title>
        {control.resetFa ? (
          <Field
            className={styles.code_input}
            type='text'
            name='Reset code'
            label={props.formatMessage({ id: "modal.2fa.reset_code" })}
            placeholder='Enter reset code'
            id='ResetCode'
            reset={reset}
            isError={!!control.error}
          />
        ) : (
          <Field
            className={styles.code_input}
            type='number'
            name='Enter Google 2FA code'
            label={props.formatMessage({ id: "modal.2fa.google_code" })}
            placeholder='Code'
            id='Code2FA'
            reset={reset}
            isError={!!control.error}
          />
        )}
        <SmallLink onClick={compireOnClick}>
          {control.resetFa ? (
            <>&lArr; {props.formatMessage({ id: "modal.2fa.return" })}</>
          ) : (
            props.formatMessage({ id: "modal.2fa.lost_code" })
          )}
        </SmallLink>
        {control.error && <Error errors={control.error} />}

        {REACT_RECAPTCH_KEY && control.resetFa && (
          <div className={cn("g-recaptcha")} style={{ margin: "5px 0" }}>
            <ReCAPTCHA
              sitekey={REACT_RECAPTCH_KEY}
              onChange={(response) =>
                response && control.setRecaptchaResponse(response)
              }
              onExpired={() => control.setRecaptchaResponse(undefined)}
              ref={control.recapRef}
            />
          </div>
        )}

        <Button type='submit' loading={control.loading}>
          {props.formatMessage({ id: "modal.2fa.confirm" })}
        </Button>
      </form>
    </div>
  );
}

export default WithModal(MODALS_ENUM.USE_TWO_FA_MODAL, TwoFaModal, {
  NC: true,
});

// 15e722eaf3f010538d48ed5e20e735e3
